/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementDataCutPaymarketMappingType {
    SOURCE_CUT_MAPPED = 'sourceCutMapped',
    SOURCE_CUT_UNMAPPED_USED = 'sourceCutUnmappedUsed',
    NEW_TARGET_CUT = 'newTargetCut',
}
